export default "__VITE_ASSET__d8d63c1f__"